import axios from 'axios';
import {EwsRepTO} from 'generated/JavaTO';

export const fetchEwsReps = () => axios.get<EwsRepTO[]>('../json/ewsRep/selectable')

export const persistEwsReps = (data: Pick<EwsRepTO, 'repAddress' | 'useFwdRule'>[]) => axios.post<void>("../json/ewsRep", data)